/**
 * AddBannerBundleCtrl controller
 * Add/edit BannerBundle
 */

import { CONTENT_TYPES, RESOURCE_TYPES, IMAGES_BUNDLE_AVAILABLE_TYPES } from 'app/core/constants'
import { getUniqueLink } from 'app/helpers/string'

/**
 * AddBannerBundleCtrl controller
 *
 * @class AddBannerBundleCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddBannerBundleCtrl
 */
/* @ngInject */
export default function AddBannerBundleCtrl ($scope, $uibModal, $uibModalInstance, Banner, alertLiteSvc, banner, bb, contentTypes, isNew) {
  const vm = this
  Banner.getPlatforms(banner.networkId, banner.subscriptions.map(s => s.id)).then(platforms => {
    vm.platforms = bb._enhancePlatforms(['STB'], platforms) // default value for new package is 'STB'
  })

  vm.subscriptionIds = banner.subscriptions.map(s => s.id)

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 25,
    sort: 'id',
    totalPages: 0
  }

  // if changed content type
  $scope.$watch('vm.bb.contentType', (n, o) => {
    if (n && n !== o) {
      vm.tableState = angular.copy(defaultTableState)

      banner._getContent(vm.tableState, { contentType: vm.bb.contentType, subscriptionIds: vm.subscriptionIds })
        .then((result) => {
          vm.tableState.totalPages = result.totalPages - 1
          vm.bb.$content = null
          return result.content || []
        })
        .to(vm.content = [])
    }
  })

  /**
   * Content types
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {Object<CONTENT_TYPES>}
   */
  vm.content_types = CONTENT_TYPES

  /**
   * Resource types
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {Object<RESOURCE_TYPES>}
   */
  vm.resource_types = RESOURCE_TYPES

  /**
   * Banner bundle
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {models.BannerBundle}
   */
  vm.bb = bb

  /**
   * Banner
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {models.Banner}
   */
  vm.banner = banner

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {Boolean}
   */
  vm.isNew = isNew

  /**
   * Platforms array
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {Object[]}
   */

  /**
   * Content types array
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   * @type {Object[]}
   */
  vm.contentTypes = contentTypes

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddSubscribersReportCtrl
   * @type {Object}
   */
  vm.tableState = angular.copy(defaultTableState)

  if (!vm.isNew && vm.bb.contentType) {
    banner._getContent(vm.tableState, { contentType: vm.bb.contentType, subscriptionIds: vm.subscriptionIds })
      .then((result) => {
        vm.tableState.totalPages = result.totalPages - 1
        return result.content || []
      })
      .to(vm.content = [])
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.refreshContent = function ($select = {}) {
    const search = $select.search || null

    vm.tableState.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    vm.tableState.q = ''
    if (vm.openCount >= 1 && search) {
      vm.tableState.q = search
    }

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        banner._getContent(vm.tableState, { contentType: vm.bb.contentType, subscriptionIds: vm.subscriptionIds })
          .then((result) => {
            vm.tableState.totalPages = result.totalPages - 1
            vm.content = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Check, if at least one platform is selected
   *
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function () {
    for (var i = vm.platforms.length; i--;) {
      if (vm.platforms[i].checked) {
        return true
      }
    }
    return false
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   */
  vm.submit = function () {
    bb._reducePlatforms(vm.platforms)
    if (bb.resourceType !== 'INTERNAL') {
      bb.contentId = null
      bb.contentType = null
    }

    if (bb.resourceType !== 'EXTERNAL') {
      bb.externalLink = null
    }
    bb.networkId = banner.networkId // hack, mix network id
    bb.tvBannerUrl = bb.tabletBannerUrl
    $uibModalInstance.close({ bb, action: null })
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddBannerBundleCtrl
   */
  vm.cancel = function ($event) {
    $event.preventDefault()
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerScroll = 0
  vm.contentCallbackScroll = (event) => {
    const { page, totalPages } = vm.tableState
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        banner._getContent({ ...vm.tableState, page: page + 1 }, { contentType: vm.bb.contentType, subscriptionIds: vm.subscriptionIds })
          .then((result) => {
            vm.tableState.page = result.number
            vm.content = vm.content.concat(result.content || [])
          })
      }, 700)
    }
  }

  //
  // Upload images

  vm.uploadPoster = function (file, properties = {}, setUrl) {
    vm.setDisable()
    const _URL = window.URL || window.webkitURL

    const parts = properties.parts
    const fileSize = properties.fileSize || 10485760
    const fileSizeName = properties.fileSizeName || `${fileSize} bytes`
    const type = properties.type

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / parts.width
      const heightPart = this.height / parts.height
      _URL.revokeObjectURL(objectUrl)

      if (fileSize && file.size > fileSize) {
        alertLiteSvc.alertError(`File bigger than ${fileSizeName}`)
        $scope.$broadcast('dndfile.clear', true)
        vm.unsetDisable()
        return
      }

      if (widthPart && heightPart && (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02)) {
        alertLiteSvc.alertError(`Aspect ratio must be ${parts.width}:${parts.height}`)
        $scope.$broadcast('dndfile.clear', true)
        vm.unsetDisable()
        return
      }

      return bb._uploadFile(`api/networks/${banner.networkId}/subscriptions/carousels/banners/upload`, file, { type }).data()
        .then((response) => {
          const url = getUniqueLink(response.resourceUrl)
          setUrl(url)
        })
        .finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.userBanners = true
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    $scope.form.$setDirty()
  }

  /**
   * Upload Mobile
   *
   * @memberof mwApp/shows.controller:AddBannerBundleCtrl
   * @function
   */
  vm.uploadMobile = (file) =>
    vm.uploadPoster(file, { parts: { width: 2, height: 3 }, fileSizeName: '10 Mb', type: IMAGES_BUNDLE_AVAILABLE_TYPES.MOBILE }, (url) => { bb.mobileBannerUrl = url })

  /**
   * Upload Tablet
   *
   * @memberof mwApp/shows.controller:AddBannerBundleCtrl
   * @function
   */
  vm.uploadTablet = (file) =>
    vm.uploadPoster(file, { parts: { width: 16, height: 9 }, fileSizeName: '10 Mb', type: IMAGES_BUNDLE_AVAILABLE_TYPES.TABLET }, (url) => { bb.tabletBannerUrl = url })

  /**
   * Upload TV
   *
   * @memberof mwApp/shows.controller:AddBannerBundleCtrl
   * @function
   */
  vm.uploadTV = (file) =>
    vm.uploadPoster(file, { parts: { width: 16, height: 9 }, fileSizeName: '10 Mb', type: IMAGES_BUNDLE_AVAILABLE_TYPES.TV }, (url) => { bb.tvBannerUrl = url })

  /**
   * Delete banner bundle
   *
   * @memberof mwApp/shows.controller:AddBannerBundleCtrl
   */
  vm.delete = function () {
    $uibModalInstance.close({ bb, action: 'delete' })
  }

  vm.changeContent = function () {
    if (vm.isNew && !vm.userBanners) {
      vm.bb.mobileBannerUrl = vm.bb.$content.portraitImageUrl
      vm.bb.tabletBannerUrl = vm.bb.$content.landscapeImageUrl
    }
  }

  vm.imgUrl = function (img, type) {
    const size = type === 'vertical' ? '141x210' : '155x90'
    return img
      ? img.indexOf('{{size}}') > -1
        ? img.replace('{{size}}', size)
        : img + (img.indexOf('?') === -1 ? `?resize=${size}` : `&resize=${size}`)
      : ''
  }

  $scope.$watch('vm.bb.name', (newVal) => {
    if (newVal) {
      vm.form.name.$setValidity('sameName', (banner.bannerBundles.filter(bb => bb.name.toLowerCase() === newVal.toLowerCase()).length <= (vm.isNew ? 0 : 1)))
    }
  })
}
